import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fileRepositoryStatus'
})
export class FileRepositoryStatusPipe implements PipeTransform {

  transform(value: string, ...args: unknown[]): unknown {
    let statusIcon;

    if (value.toLowerCase() === 'active') {
      statusIcon = '<i title="Active" class="fa fa-check active"></i>';
    } else if ((value.toLowerCase() === 'error')) {
      statusIcon = '<i title="Active" class="fa fa-exclamation error"></i>';
    } else {
      statusIcon = '<i title="Initializing" class="fa fa-refresh initializing"></i>';
    }

    return `<div class="center-content">${statusIcon}</div>`;
  }
}
